import React, { useRef, useState } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';
import GroupWalls from '../../../../components/GroupWalls';
import Spinner from '../../../../components/Loaders/Spinner';
import Alert from '../../../../components/Alert';
import FormSwitch from '../../../../components/FormSwitch';

const CompletePaymentModal = ({ open, item, error, isLoading, onHide, onSubmit }) => {
  const formNode = useRef(null);
  const [isOpenAmount, setOpenAmount] = useState(false);
  const showAmount = !!item?.access?.set_another_amount;

  const onSubmitForm = () => {
    const current = formNode?.current;
    const formData = {
      memo: current?.memo?.value,
      type: item.type,
    };

    if (showAmount && current?.amount?.value) {
      formData.amount = current?.amount?.value;
    }

    onSubmit?.(formData, 'complete');
  };

  return (
    <Modal show={open} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{item.type === 0 ? 'Accept payment' : 'Complete payment'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert text={error} />}
        <form ref={formNode} onSubmit={onSubmitForm}>
          <FormGroup>
            <ControlLabel>Memo</ControlLabel>
            <FormControl type="text" name="memo" defaultValue={item.memo} />
          </FormGroup>
          {showAmount
            ? (
              <GroupWalls.Wrapper>
                <GroupWalls.Item active={isOpenAmount}>
                  <>
                    <FormSwitch id="amount_switch" name="amount_switch" checked={isOpenAmount} onChange={() => setOpenAmount(!isOpenAmount)}>
                      Set another payment amount
                    </FormSwitch>
                    <Collapse in={isOpenAmount}>
                      <div className="mt-10">
                        <FormControl
                          type="number"
                          name="amount"
                          defaultValue=""
                        />
                      </div>
                    </Collapse>
                  </>
                </GroupWalls.Item>
              </GroupWalls.Wrapper>
            ) : null}
        </form>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoading} onClick={onSubmitForm}>
          {isLoading && <Spinner />}
          <span>{item.type === 0 ? 'Accept' : 'Complete'}</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CompletePaymentModal.propTypes = {
  open: PropTypes.bool,
  item: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CompletePaymentModal;
